export interface AuthState {
  isAuthenticated: boolean
  isLoading: boolean
  permissions: TWPERMISSIONS[]
}

// These permissions are set by the groups in Google Workspace.
//In order for the user to have access with these permissions they will need to be added to the respective security group
export enum TWPERMISSIONS {
  SUPPORT = 'thrivecore-support',
  PATIENT = 'thrivecore-patient',
  CLINICIAN = 'thrivecore-clinicians',
  RCD = 'thrivecore-rcd',
  DEVOPS_ADMIN = 'thrivecore-devops admin',
  CLINICAL_ADMIN = 'thrivecore-clinical admin',
  SOFTWARE_DEVS = 'software-devs',
  THIRD_PARTY_SUPPORT = 'thirdparty-support',
  ENG_SUPPORT_1 = 'thrivecore-eng-support-1',
  THRIVECARE_ADMIN = 'thrivecore-thrivecare-admin',
  PRODUCT_TEAM = 'thrivecore-product',
}

export enum IdentityUserTypes {
  SUPPORT = 'support',
  PATIENT = 'patient',
  CLINICIAN = 'clinician',
  RCD = 'rcd',
  THIRD_PARTY_SUPPORT = 'third_party_support',
}
